<template>
  <div>
    <NavBar></NavBar>
    <SideMenu></SideMenu>
    <v-main
      :style="{
        'margin-left': '240px',
        'background-color': '#f1f2f8',
        'min-height': '100vh',
      }"
    >
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import SideMenu from '@/components/SideMenu.vue';

export default {
  name: 'DefaultLayout',
  components: {
    NavBar,
    SideMenu,
  },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
// @import '@/assets/scss/main.scss';
</style>
